import { Component, OnInit } from '@angular/core'
import { EndRishumService } from './end-rishum.service';
import { Router } from '@angular/router';
import { IEndRishum } from './end-rishum'


@Component({
    moduleId: module.id,
    templateUrl: './end-rishum.component.html',
    providers: [EndRishumService],
})


export class EndRishumComponent implements OnInit {

    end_rishum: IEndRishum;

    constructor(private _endRishumService: EndRishumService, public router: Router) {

    }
    ngOnInit(): void {
        this._endRishumService.getEndRishum()
            .subscribe((e: IEndRishum) => {
                this.end_rishum = e;
            },
            error => {
                localStorage.removeItem("token");
                location.reload();

            })

    }

}